import { createContext } from 'react';
import { IItemForGetShortInfoWithStatus, TPropertiesOfPatchChangesForCategory } from 'types';

export type TTypeOfModalWindow = Nullable<'toConfirmFieldsClearing' | 'error'>;

export interface ISaveAsPatchState {
	initialFormData: {
		categoryId: string;
		customerName: string;
		fetchedRestaurants: IItemForGetShortInfoWithStatus[];
		IDSelectedRestaurantOnRestPropsPage: Nullable<string>;
		hasSchedulePriority: boolean;
		activationSchedule: string;
		deactivationSchedule: string;
	};
	typeOfChanges: 'basedChanges' | 'independentChanges';
	IDsSelectedRestaurant: string[];
	activationSchedule: string;
	deactivationSchedule: string;
	selectedProperties: TPropertiesOfPatchChangesForCategory[];
	typeOfModalWindow: TTypeOfModalWindow;
}

export const saveAsPatchInitialState: ISaveAsPatchState = {
	initialFormData: {
		categoryId: '',
		customerName: '',
		fetchedRestaurants: [],
		IDSelectedRestaurantOnRestPropsPage: null,
		hasSchedulePriority: false,
		activationSchedule: '',
		deactivationSchedule: '',
	},
	typeOfChanges: 'basedChanges',
	IDsSelectedRestaurant: [],
	activationSchedule: '',
	deactivationSchedule: '',
	selectedProperties: [],
	typeOfModalWindow: null,
};

export interface ISaveAsPatchContext extends ISaveAsPatchState {
	saveData(value: 'saveAndMakeOtherChanges' | 'saveAndClose'): void;
	setTypeOfChanges(value: ISaveAsPatchState['typeOfChanges']): void;
	setIDsRestaurant(value: ISaveAsPatchState['IDsSelectedRestaurant']): void;
	setProperties: (value: ISaveAsPatchState['selectedProperties']) => void;
	changeActivationSchedule(value: ISaveAsPatchState['activationSchedule']): void;
	changeDeactivationSchedule(value: ISaveAsPatchState['deactivationSchedule']): void;
	changeTypeOfModalWindow(value: ISaveAsPatchState['typeOfModalWindow']): void;
}

export const SaveAsPatchContext = createContext<ISaveAsPatchContext>({
	saveData: () => undefined,
	setTypeOfChanges: () => undefined,
	setIDsRestaurant: () => undefined,
	setProperties: () => undefined,
	changeActivationSchedule: () => undefined,
	changeDeactivationSchedule: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	...saveAsPatchInitialState,
});
